// @flow

export const RobotoNormal = {
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  weight: 400,
}

export const RobotoMedium = {
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  weight: 500,
}

export const RobotoBold = {
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  weight: 700,
}

export const RobotoBlack = {
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  weight: 900,
}
